import { List } from 'immutable';
import * as A from '@/domain/dictionary/actions';

export const reducer = {
  currencies(state = new List(), action) {
    switch (action.type) {
      case A.getCurrenciesAction.success:
        return action.payload;

      default:
        return state;
    }
  },
  timezones(state = new List(), action) {
    switch (action.type) {
      case A.getTimezonesAction.success:
        return action.payload;

      default:
        return state;
    }
  },
};
